import { SelectOptionItem } from 'components/elements/Select/Select.styled';
import { css, styled } from 'styles';
import { StyledSelectListItemProps } from './types';

const disabledStyles = css`
  &:hover {
    background-color: unset;
    cursor: default;
  }
`;

const selectedStyles = css`
  background-color: ${({ theme }) => theme.selectList.option.selected.background};
  color: ${({ theme }) => theme.selectList.option.selected.color};

  * {
    color: ${({ theme }) => theme.selectList.option.selected.color} !important;
  }

  &:hover {
    background-color: ${({ theme }) => theme.selectList.option.selected.background};
    color: ${({ theme }) => theme.selectList.option.selected.color};
  }
`;

export const StyledSelectListItem = styled(SelectOptionItem)<StyledSelectListItemProps>`
  ${({ $disabled }) => $disabled && disabledStyles};
  ${({ $selected }) => $selected && selectedStyles};
`;

StyledSelectListItem.displayName = 'SelectListItem.Styled';
